import React from "react";

import type { JSX } from "react";

interface Props {
  title: string | React.ReactNode;
  children: React.ReactNode;
}

export default function SidepanelBlock({
  title,
  children,
}: Props): JSX.Element {
  return (
    <div className="border-border mb-[0.9375rem] border-b pb-[0.9375rem] last:border-none [&>*:last-child]:mb-0">
      <div className="mb-[0.46875rem] text-[1.171875rem] font-semibold">
        {title}
      </div>
      {children}
    </div>
  );
}
